/**
 * Shared overlay colors for the cranial editor (SVG) and the annotated image export (canvas).
 * Chosen to stay readable over skin, hair and the usual clinic backgrounds.
 */
export const COLORS = {
  contour: "#5A80FB",
  contourFill: "rgba(90, 128, 251, 0.14)",
  contourPoint: "#FFFFFF",
  selected: "#FF3383",
  ghost: "rgba(255, 255, 255, 0.85)",
  length: "#FFC53D",
  width: "#22C55E",
  diagonalA: "#FF3383",
  diagonalB: "#00C2FF",
  landmark: "#FFC53D",
  landmarkText: "#1A1A2E",
  derived: "#FFFFFF",
  scale: "#A855F7",
  center: "#FFFFFF",
  halo: "rgba(26, 26, 46, 0.55)",
  labelBox: "rgba(26, 26, 46, 0.78)",
  labelText: "#FFFFFF",
};

/** Measurement lines in drawing / legend order. `lineKey` is the key in `measurements.lines`. */
export const MEASUREMENT_LINES = [
  { key: "length", lineKey: "apAxis", label: "Comprimento (A-P)", color: COLORS.length },
  { key: "width", lineKey: "width", label: "Largura (orelha a orelha)", color: COLORS.width },
  { key: "diagonalA", lineKey: "diagonalA", label: "Diagonal A", color: COLORS.diagonalA },
  { key: "diagonalB", lineKey: "diagonalB", label: "Diagonal B", color: COLORS.diagonalB },
];

/**
 * Point labels. nose / earLeft / earRight are the draggable landmarks (protocol v2.1);
 * anterior is the derived axis crossing with the contour (not draggable); posterior is
 * derived while automatic and becomes a draggable landmark once the user moves it.
 */
export const LANDMARK_LABELS = {
  nose: { short: "N", long: "Nariz" },
  earLeft: { short: "O", long: "Orelha" },
  earRight: { short: "O", long: "Orelha" },
  anterior: { short: "A", long: "Frente" },
  posterior: { short: "P", long: "Trás" },
};

/** Draggable landmark keys, in drawing order. */
export const LANDMARK_KEYS = ["nose", "earLeft", "earRight"];

/** Protocol description shown in the measurement panel, the results footer and README 4. */
export const PROTOCOL_NOTE =
  "Protocolo v2.1 baseado no método Skully Care: eixo pela reta N-P, com P sugerido pela regra Skully (eixo pelo ponto médio das orelhas, cruzamento posterior com o contorno) e ajustável, A no cruzamento da reta com o contorno do lado do nariz, largura entre as bordas anteriores das orelhas, diagonais a ±30° pelo meio do comprimento, CVAI = (maior − menor) / menor.";
